export enum PlanType {
  "Assessment" = 1,
  "Strategic",
  "Degree",
  "Administrative",
}
